import React, { useState } from 'react';

const CopyDiscord = () => {
  const [copied, setCopied] = useState(false);
  const username = 'firecharge1';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(username);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  return (
    <div onClick={handleCopy} className="social reveal-on-scroll" style={{ cursor: 'pointer' }}>
      <img src={process.env.PUBLIC_URL + "./contactIcons/Discord.png"} alt="Discord:" />
      <p>{copied ? 'Copied to clipboard' : `${username} (copy)`}</p>
    </div>
  );
};

export default CopyDiscord;